import { RootTitle } from './root-title.component';
import { jsx as _jsx } from "react/jsx-runtime";
export var Heading4 = function Heading4(props) {
  var children = props.children;
  return /*#__PURE__*/_jsx(RootTitle, {
    level: 4,
    children: children
  });
};